export const userHasRole = (groups: any, roleGroups?: (string | null)[] | null | undefined) => {
  if (!roleGroups) return false;
  if (!groups) return false;
  return groups.some((group) => {
    return roleGroups.includes(group);
  });
};
